import ModalSelect from "./ModalSelect";
import Utils from "./Utils";

export default class CityChanger {
  constructor() {
    this.select_modal = null;

    this.get_param_name = "city_change";

    this.elements_ids = {
      main_btn: "city-changer__main-btn", // Отвечает за открывашку выбора
      parent_block: "city-changer__parent-block", // Родительский элемент где будет расположена модалка.
      mobile_header_block: "city-changer__mobile-header-block", // Элемент куда будет перемещен выбор города на мобиле
    };

    this.default_city_name = "Санкт-Петербург";
    this.api_city_by_ip = "https://www.travelpayouts.com/whereami?locale=ru"; // api для получения города по ip

    this.ModalSelect = new ModalSelect(this);
    this.Utils = new Utils();
  }

  async init() {
    // Функция для удаления GET-параметра из URL
    this.Utils.removeQueryParam(this.get_param_name);

    // Проверили есть ли на странице родительский элемент
    const parent_block = this.Utils.checkElement(
      "#" + this.elements_ids.parent_block,
      "Не найден родительский элемент"
    );
    if (typeof parent_block !== "object") return;

    // Слушатель для основной кнопки выбора города
    this.ModalSelect.events.open("#" + this.elements_ids.main_btn);

    // Перестановка для мобилы
    this.Utils.moveMobileParentBlock(
      "#" + this.elements_ids.mobile_header_block,
      "#" + this.elements_ids.parent_block
    );

    // Получаем город пользователя
    this.getUserCity();
  }

  async getUserCity() {
    // Если город не заполнен (достается из cookie на бэке), тогда определяем по ip
    const main_btn = this.Utils.checkElement("#" + this.elements_ids.main_btn);
    if (typeof main_btn !== "object") return;

    // Город через пвсевдокласс. Приколюхи СЕО
    const pseudoCityText = (value) => {
      this.Utils.addPseudoTextStyle([
        {
          selector: ".pseudo-text__city",
          styles: [
            { name: "content", value },
            { name: "font-weight", value: "bold" },
          ],
        },
      ]);
    };

    if (
      main_btn.dataset.content == "" &&
      main_btn.dataset.content.trim().length <= 1
    ) {
      const city_by_ip = await this.getCityByIp();

      pseudoCityText(city_by_ip);

      // cookie для бэка. Чтобы сразу оттобразить на странице при перезагрузке, и не отправлять по апи запрос повторно
      document.cookie = "city_name=" + city_by_ip;
    } else {
      pseudoCityText(main_btn.dataset.content);
    }
  }

  async getCityByIp() {
    let city_name = "";
    await fetch(this.api_city_by_ip)
      .then((response) => response.json())
      .then((data) => {
        city_name = data.name;
      })
      .catch((error) => {
        console.error("Ошибка при определении города:", error);
      })
      .finally(() => {
        if (
          !city_name.trim() ||
          city_name.trim() == "" ||
          city_name.trim() == "undefined"
        )
          city_name = this.default_city_name;
      });

    return city_name;
  }
}